import React from 'react';
import { useDispatch } from 'react-redux';

import "./styles.scss";
import BackArrow from './../../assets/BackArrow.svg'
import { openLeftPanel } from "./../../services/StoreContainer/actionCreators";

export default function LeftPanelHeader(props) {
    const dispatch = useDispatch();

    return <>
        <div className="headerContainer">
            <img src={BackArrow} className='backArrow' alt='back arrow' onClick={() => {
                dispatch(openLeftPanel(null));
            }} />
            <div className='titleContainer'><p className="headerMargin">{props.sectionName}</p></div>
        </div>
        {props.dataset &&
            <div className="bottomHeaderContainer">
                <p>{props.dataset.name}</p>
            </div>
        }
    </>
}
